// extracted by mini-css-extract-plugin
export default {"login":"Login_login__yplOB","forms":"Login_forms__rVkPe"};